"use client"

import IndexFooter from "@repo/ui/footer"
import { useEffect, type ReactNode } from "react"
import { App, ConfigProvider } from "antd"

import "@ant-design/v5-patch-for-react-19"

import { setGlobalModalInstance } from "@/common/utils/modal"
import { getAntdLocale } from "@repo/shared"
import { useLocale } from "next-intl"

interface LocaleLayoutProps {
	children: ReactNode
}

function ModalProvider({ children }: { children: ReactNode }) {
	const { modal } = App.useApp()
	useEffect(() => {
		setGlobalModalInstance(modal)
	}, [modal])
	return <>{children}</>
}

export function LocaleLayout({ children }: LocaleLayoutProps) {
	const hookLocale = useLocale()
	const locale = hookLocale || "en"

	// 根 layout 无法拿到 locale，在此同步 html lang 以配合 i18n
	useEffect(() => {
		document.documentElement.lang = locale
	}, [locale])
	const antdLocale = getAntdLocale(locale)
	const fontFamilyMap: Record<string, string> = {
		th: "var(--font-noto-sans-thai), var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif",
		ko: "var(--font-noto-sans-kr), var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif",
	}
	const fontFamily = fontFamilyMap[locale] ?? "var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif"

	return (
		<ConfigProvider
			locale={antdLocale}
			theme={{
				token: {
					fontFamily,
					colorPrimary: "#d7000f",
					borderRadius: 2,
				},
			}}
		>
			<App>
				<ModalProvider>
					{children}
					<IndexFooter />
				</ModalProvider>
			</App>
		</ConfigProvider>
	)
}
